import {useState, useEffect, useRef} from 'react'

const useSetTimer = (time) => {
    const Ref = useRef<NodeJS.Timeout | null>(null)
    const [timer, setTimer] = useState('00 : 00 : 00 : 00')

    const calculateTimer = (date) => {
        if (Ref.current) {
            clearInterval(Ref.current)
        }

        const id = setInterval(() => {
            const total = Date.parse(date) - Date.now()
            const seconds = Math.floor((total / 1000) % 60)
            const minutes = Math.floor((total / 1000 / 60) % 60)
            const hours = Math.floor((total / 1000 / 60 / 60) % 24)
            const days = Math.floor(total / 1000 / 60 / 60 / 24)

            if (total >= 0) {
                setTimer(
                    `${days > 9 ? days : '0' + days} : ${hours > 9 ? hours : '0' + hours} : ${minutes > 9 ? minutes : '0' + minutes} : ${seconds > 9 ? seconds : '0' + seconds}`,
                )
            }
        }, 1000)

        Ref.current = id
    }

    useEffect(() => {
        calculateTimer(new Date(time))
    }, [])

    return timer
}

export {useSetTimer}
